import { c as _c } from "react/compiler-runtime";
import { Overline } from "@repo/ui/overline";
import { cn } from "@repo/ui/utils";
import { RichTextCondensed } from "@/components/common/rich-text/rich-text-condensed.component";
import type { ApartmentListingSectionHeader } from "./apartment-listing.types";
interface ApartmentListingHeaderProps extends ApartmentListingSectionHeader {
  className?: string;
}
export function ApartmentListingHeader(t0) {
  const $ = _c(13);
  const {
    overline,
    headline,
    bodyCopy,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col gap-4 tablet:gap-6", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== overline) {
    t2 = overline && <Overline variant="muted">{overline}</Overline>;
    $[2] = overline;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== headline) {
    t3 = <h2 className="typography-mobile-heading-h5 tablet:typography-desktop-heading-h5 text-text-primary">{headline}</h2>;
    $[4] = headline;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== bodyCopy) {
    t4 = bodyCopy && <RichTextCondensed richText={bodyCopy} as="body-tablet" compact={true} className="text-text-secondary" />;
    $[6] = bodyCopy;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}